import * as classMappings from "./index";
import { revive } from "./serializer";
import { v4 as uuidv4 } from "uuid";

class BaseRepository {
    constructor(table, memoryCache) {
        this.table = table;
        this.memoryCache = memoryCache;

        table.hook("reading", (obj) => {
            this.memoryCache?.set(obj);
            return revive(obj, classMappings);
        });

        table.hook("creating", (primKey, obj) => {
            if (!obj.id) {
                obj.id = uuidv4();
            }
            this.memoryCache?.set(obj);
        });

        table.hook("updating", (modifications, primKey, obj) => {
            this.memoryCache?.set(obj);
        });

        table.hook("deleting", (primKey, obj) => {
            this.memoryCache?.evict(obj.id);
        });
    }

    add(obj, key) {
        const toAdd = {
            ...obj.toJSON(),
            createdAt: new Date().toISOString()
        };
        return this.table.add(toAdd, key);
    }

    put(obj, key) {
        const toPut = {
            ...obj.toJSON(),
            createdAt: new Date().toISOString()
        };
        return this.table.put(toPut, key);
    }

    update(key, changes) {
        const toUpdate = {
            ...changes,
            updatedAt: new Date().toISOString()
        };
        return this.table.update(key, toUpdate);
    }

    bulkAdd(items, keys, options) {
        const toAdd = items.map((i) => {
            i.createdAt = new Date().toISOString();
            if (!i.toJSON) {
                console.error("Object class not mapped", i);
                return i;
            } else {
                return i.toJSON();
            }
        });
        return this.table.bulkAdd(toAdd, keys, options);
    }

    bulkPut(items, keys, options) {
        const toPut = items.map((i) => {
            i.createdAt = new Date().toISOString();
            if (!i.toJSON) {
                console.error("Object class not mapped", i);
                return i;
            } else {
                return i.toJSON();
            }
        });
        return this.table.bulkPut(toPut, keys, options);
    }

    bulkDelete(keys) {
        return this.table.bulkDelete(keys);
    }

    delete(pk) {
        return this.table.delete(pk);
    }

    where(obj) {
        return this.table.where(obj);
    }

    getById(id) {
        return this.table.get(id);
    }

    getAll() {
        return this.table.toCollection();
    }

    getTable() {
        return this.table;
    }

    getByIds(ids) {
        return this.table.bulkGet(ids);
    }

    getFromCacheSync(id) {
        return this.memoryCache
            ? revive(this.memoryCache.get(id), classMappings)
            : null;
    }

    mapToEntity(jsonEntity) {
        return revive(jsonEntity, classMappings);
    }
}

export default BaseRepository;
